var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('em',{staticClass:"is-size-5"},[_vm._v(_vm._s(_vm.$t('app-last-updated-text'))+" "+_vm._s(_vm.msg)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }